import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const COMPETITION_SECRETARY_REQUEST = 'FETCH_COMPETITION_SECRETARY_REQUEST';
export const COMPETITION_SECRETARY_FAILURE = 'FETCH_COMPETITION_SECRETARY_FAILURE';
export const COMPETITION_SECRETARY_SUCCESS = 'FETCH_COMPETITION_SECRETARY_SUCCESS';

export const fetchCompetitionSecretaries = () => {
    return function(dispatch) {
        dispatch(fetchRequest());
        return axios(apiRequestOptions(apiPath.COMPETITION_SECRETARIES.LIST))
            .then(transformHttpResponse)
            .then(response => dispatch(fetchSuccess(response.data)))
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(fetchFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const fetchRequest = () => ({type: COMPETITION_SECRETARY_REQUEST});
const fetchFailure = error => ({type: COMPETITION_SECRETARY_FAILURE, error});
const fetchSuccess = data => ({type: COMPETITION_SECRETARY_SUCCESS, data});